import { render, staticRenderFns } from "./OffersIndex.vue?vue&type=template&id=590ecc0d"
import script from "./OffersIndex.vue?vue&type=script&lang=js"
export * from "./OffersIndex.vue?vue&type=script&lang=js"
import style0 from "./OffersIndex.vue?vue&type=style&index=0&id=590ecc0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports